import React from 'react';
import { motion } from 'framer-motion';
import Lesson from './Lesson';
import { useTheme } from '../contexts/ThemeContext';

const Subfolder = ({ subfolder, folderIndex, subfolderIndex, completedLessons, toggleComplete, isUnlocked }) => {
  const { isDarkMode } = useTheme();
  
  const completableLessons = subfolder.lessons.filter(lesson => lesson.type !== 'text');
  const completedCount = completableLessons.filter(lesson => completedLessons.includes(lesson.id)).length;
  const totalCount = completableLessons.length;

  return (
    <motion.div 
      className={` border-2 rounded-custom overflow-hidden shadow-custom-sm hover:shadow-custom-md hover:border-primary-600 transition-all duration-300 ${!isUnlocked ? 'opacity-60 pointer-events-none filter grayscale-50' : ''} ${isDarkMode ? 'border-gray-600 hover:border-primary-500' : 'border-gray-200'} `}
      whileHover={isUnlocked ? { y: -2 } : {}}
    >
      <div className={`bg-gradient-to-r from-purple-600 to-primary-600 text-white p-4 relative ${isDarkMode ? 'from-purple-700 to-primary-700' : ''}`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <h3 className="font-bold text-lg">{subfolder.title}</h3>
          <motion.span 
            className="bg-white/20 px-3 py-1 rounded-custom text-sm font-semibold backdrop-blur-sm"
            key={`${completedCount}-${totalCount}`}
            initial={{ scale: 1.1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.2 }}
          >
            {completedCount}/{totalCount}
          </motion.span>
        </div>
      </div>
      
      <div className={`divide-y transition-colors duration-300 ${isDarkMode ? 'divide-gray-600' : 'divide-gray-200'}`}>
        {subfolder.lessons.map((lesson, lessonIndex) => (
          <Lesson
            key={lesson.id}
            lesson={lesson}
            isCompleted={completedLessons.includes(lesson.id)}
            onToggleComplete={() => toggleComplete(lesson.id)}
            isFirst={lessonIndex === 0}
          />
        ))}
      </div>

      {!isUnlocked && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/90 text-white p-4 text-center rounded-custom backdrop-blur-sm z-10">
          <motion.div 
            className="bg-black/80 px-6 py-4 rounded-2xl shadow-custom-lg backdrop-blur-md"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <span className="font-semibold">🔒 Completa la sottocartella precedente per sbloccare</span>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default Subfolder;